// src/components/core/SEO.tsx

interface SEOProps {
  title?: string;
  description?: string;
  url?: string;
  image?: string;
  noIndex?: boolean;
}

const BASE_URL = "https://www.surfanzeigen.de";
const DEFAULT_IMAGE = `${BASE_URL}/logo512.png`;

export default function SEO({
  title = "Surfanzeigen",
  description = "Gebrauchtes Windsurfmaterial, Kitematerial für Wassersportler: Segel, Boards und vieles mehr. Erkunde die Inserate fürs Windsurfen, Kiten oder SUP.",
  url,
  image = DEFAULT_IMAGE,
  noIndex = false,
}: SEOProps) {
  const fullTitle =
    title === "Surfanzeigen"
      ? "Surfanzeigen - Gebrauchtes Material fürs Windsurfen, Kiten, Wassersport"
      : `${title} | Surfanzeigen`;
  const fullUrl = url ? `${BASE_URL}${url}` : BASE_URL;
  const descriptionTrunc =
    description.length > 155 ? description.slice(0, 152) + "..." : description;
  return (
    <>
      <title>{fullTitle}</title>
      {noIndex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <meta name="robots" content="index, follow" />
      )}

      {/* OpenGraph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={descriptionTrunc} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="Surfanzeigen" />
      <meta property="og:locale" content="de_DE" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={descriptionTrunc} />
      <meta name="twitter:image" content={image} />
      {/* Canonical */}
      <link rel="canonical" href={fullUrl} />
    </>
  );
}
